import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import YesNo from '../../../../components/YesNo';
import ManagementTable from '../../components/ManagementTable';
import VehicleTypeForm from '../../forms/VehicleTypeForm';

const VehicleTypes = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Vehicle Types"
      addTitle="Add New Type"
      editTitle="Edit Type"
      columns={[
        {title: 'Name', field: 'name'},
        {title: 'Scorpion Reference', field: 'scorpion_reference'},
        {title: 'UKVD Reference', field: 'ukvd_reference'},
        {title: 'Default?', field: 'is_default', render: data => <YesNo value={data.is_default}/>},
      ]}
      loadData={async (query) => services.vehicleType.getTableTypes(query)}
      renderForm={(props, type, onSaved) => (
        <VehicleTypeForm
          {...props}
          type={type ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  );
};

export default VehicleTypes;
